<script setup>
import { computed } from 'vue';

  const inputValue = defineModel();

  const props = defineProps({
    modalTitle: {
      type: String,
      required: true
    },
    labelText: {
      type: String,
      default: null
    },
    acceptButtonText: {
      type: String,
      default: 'Save'
    },
    required: {
      type: Boolean,
      default: false
    }
  });

  const emit = defineEmits(['cancel', 'accept']);

  const labelText = computed(() => {
    return props.required ? props.labelText + '<span class="jwx-modal__control-required">Required</span>' : props.labelText;

  })

  function onCancel() {
    emit('cancel');
  }

  function onAccept() {
    emit('accept');
  }
</script>

<template>
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">{{ props.modalTitle }}?</h2>
    </header>
    <div class="jwx-modal__body">
      <div class="jwx-modal__section">
        <div class="jwx-modal__form-control">
          <label 
            v-if="props.labelText" 
            for="container-name" 
            class="jwx-modal__control-label" 
            :class="{ 'jwx-flex': props.required }"
            v-html="labelText"
          ></label>
          <input
            v-model="inputValue"
            type="text"
            id="container-name"
            name="container-name"
            class="jwx-modal__input" />
        </div>
      </div>
    </div>         
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button
          type="button"
          @click.prevent="onCancel"
          class="jwx-button"
        >
          Cancel
      </button>
        <button 
          type="button" 
          @click.prevent="onAccept"
          class="jwx-button jwx-button--success"
        >
          {{ props.acceptButtonText }}
        </button>
      </div>
    </div>
</template>